<template>
  <div id="app">
    <IndexPage  v-if="show()"></IndexPage>
    <router-view/>
  </div>
</template>

<script>
import IndexPage from './components/IndexPage.vue'
export default {
  components: { IndexPage },
  name: 'App',
  data () {
    return {
      show: function () {
        if (this.$route.path === '/login' || this.$route.path === '/update' || this.$route.path === '/show') {
          return false
        }
        return true
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue